uniform float time;
uniform float progress;
uniform float opacity;
uniform float dir;
uniform float copies;
uniform sampler2D uTexture;
uniform vec4 resolution;
varying vec2 vUv;
varying vec3 vPosition;
float PI = 3.141592653589793238;
void main()	{
	gl_FragColor = texture2D(uTexture, vUv);
}